import { render, staticRenderFns } from "./movetable.vue?vue&type=template&id=81b96754&scoped=true&"
import script from "./movetable.vue?vue&type=script&lang=js&"
export * from "./movetable.vue?vue&type=script&lang=js&"
import style0 from "./movetable.vue?vue&type=style&index=0&id=81b96754&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81b96754",
  null
  
)

export default component.exports